import { useEffect, useReducer } from "react";

import {
  createInitialExperienceState,
  experienceReducer,
  savePreferences,
} from "./experience-state";

function browserStorage(): Storage | undefined {
  return typeof window === "undefined" ? undefined : window.localStorage;
}

export function useExperience() {
  const [state, dispatch] = useReducer(
    experienceReducer,
    undefined,
    () => createInitialExperienceState(browserStorage()),
  );

  useEffect(() => {
    savePreferences(browserStorage(), state);
  }, [state]);

  return { state, dispatch } as const;
}
